"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrcadTextCodec = void 0;
class OrcadTextCodec {
    decode(raw) {
        let text = '';
        const transforms = [];
        let inputIndex = 0;
        while (inputIndex < raw.length) {
            const hasOpeningMarker = raw.substring(inputIndex, inputIndex + 2) === '\\\\';
            const runStart = inputIndex + (hasOpeningMarker ? 2 : 0);
            let runEnd = runStart;
            let runLength = 0;
            while (runEnd + 1 < raw.length && raw[runEnd] !== '\\' && raw[runEnd + 1] === '\\') {
                runLength++;
                runEnd += 2;
            }
            if (runLength > 0 && (hasOpeningMarker || runLength > 1)) {
                const from = text.length;
                for (let index = runStart; index < runEnd; index += 2) {
                    text += raw[index];
                }
                transforms.push({ type: 'bar', from, to: text.length });
                inputIndex = runEnd;
                continue;
            }
            text += raw[inputIndex];
            inputIndex++;
        }
        return { text, transforms };
    }
}
exports.OrcadTextCodec = OrcadTextCodec;
//# sourceMappingURL=OrcadTextCodec.js.map